/**
 * This converter function converts a string to a number
 * @param vaultValue The vault value that you want converted to a number
 * @returns The string casted to a number
 */
export const convertStringtoNumber = (vaultValue: string) => {
    return Number(vaultValue);
};
